import React, { ReactElement, useContext } from 'react';
import StyledSVG from './Logo.styled';
import { ComponentProps as Props, Mode } from './Logo.types';
import Context from '../../molecules/Nav/Context';
import { Variant } from '../../molecules/Nav/Nav.types';

const Logo: React.FC<Props> = ({ variant, ...props }): ReactElement<Props> => {
  const ctx = useContext(Context);
  const variantMap = new Map<Variant, Mode>([
    ['light', 'dark'],
    ['white', 'dark'],
    ['dark', 'light'],
    ['website', 'light'],
  ]);

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width="295.88"
      height="49.35"
      viewBox="0 0 295.88 49.35"
      variant={variant || variantMap.get(ctx.variant)}
      {...props}>
      <g id="LM_Logo_plum" transform="translate(-20.65 -13.25)">
        <path
          className="text"
          id="Path_1"
          data-name="Path 1"
          d="M20.65,54.31V51.72c5.41-.23,6-.76,6-4.93V21.86c0-4.17-.59-4.7-6-4.93V14.34H42.94v2.59c-6.26.23-6.91.76-6.91,4.93V45.61c0,3.76,1.5,5.23,5.34,5.23h4c5.67,0,8.8-2.29,11-10.52h4.17l-1.69,14Z"
        />
        <path
          className="text"
          id="Path_2"
          data-name="Path 2"
          d="M62.48,54.31V52.08c3.65-.24,4.44-.65,4.44-5V35.32c0-3.23-.85-4.11-4.31-4.11V29l10.17-2.9h2.6v21c0,4.35,1,4.76,4.24,5v2.23Zm2.61-36c0-3,2.28-5.06,5.67-5.06s5.6,2.06,5.6,5.06-2.28,5.11-5.6,5.11-5.67-2.09-5.67-5.14Z"
        />
        <path
          className="text"
          id="Path_3"
          data-name="Path 3"
          d="M101.84,26.45h12.9v2.23c-2.28.3-3.65,2.18-5,5.29l-9,20.34H95.32l-9-19.22c-2.61-5.47-3.07-6.29-5.35-6.41V26.45H98.06v2.23c-2.41.06-3.85.94-3.85,2.59a5.24,5.24,0,0,0,.53,2l5.53,12.46L105.55,34a5.65,5.65,0,0,0,.65-2.47c0-1.88-1.56-2.76-4.36-2.82Z"
        />
        <path
          className="text"
          id="Path_4"
          data-name="Path 4"
          d="M143,44.79c-1.57,6.93-5.87,10.34-13,10.34-8.73,0-14.33-5.64-14.33-14.28,0-9.41,5.73-15.11,15-15.11,7.89,0,12.25,4.18,12,11.64h-19.2v.53c0,5.76,3.52,9.29,9.45,9.29,3.58,0,5.86-1.41,7.1-3.47ZM123.8,34.27h10.75c0-3.77-1.57-5.53-4.56-5.53C126.66,28.74,124.58,30.74,123.8,34.27Z"
        />
        <path
          className="text"
          id="Path_5"
          data-name="Path 5"
          d="M201.66,45.73c.45,4.76,1.3,5.64,5.6,6v2.59H185.69v-2.6c5.93-.29,7.24-1.06,6.78-6.29l-2.09-23L177.55,54.31h-5.86L159.11,22.69,156.9,44.55c-.59,5.59.71,6.88,6.31,7.17v2.59H146.27V51.72c4.63-.29,5.61-1.53,6.13-7.17l2.21-22.92c.4-4-.52-4.59-5.6-4.7V14.34h16.81l11.34,29.27L189,14.34h16v2.59c-4.95.11-6.06.82-5.67,4.7Z"
        />
        <path
          className="text"
          id="Path_6"
          data-name="Path 6"
          d="M208.24,40.44c0-8.94,6.77-14.7,16.48-14.7s16.49,5.76,16.49,14.7-6.78,14.69-16.49,14.69S208.24,49.37,208.24,40.44Zm22.8.88c0-5.76-1.82-12-6.58-12-3.26,0-6.06,2.41-6.06,10.34,0,5.76,1.83,12,6.58,12,3.26-.06,6.02-2.46,6.02-10.34Z"
        />
        <path
          className="text"
          id="Path_7"
          data-name="Path 7"
          d="M270.92,30.62a4.47,4.47,0,0,1-4.63,4.7c-3.13,0-3.65-3.29-5.28-3.93a19.49,19.49,0,0,0-4.3,7.23v9.75c0,2.59,1.11,3.41,4.89,3.71v2.23H244.46V52.08c3.33-.24,3.78-.65,3.78-3.71v-13c0-3.29-.78-4.11-3.78-4.11V29l9.65-2.88h2.6v7.75c1.83-4.17,4.7-8.11,8.73-8.11C268.51,25.74,270.92,27.57,270.92,30.62Z"
        />
        <path
          className="text"
          id="Path_8"
          data-name="Path 8"
          d="M299.52,44.79c-1.56,6.93-5.86,10.34-13,10.34-8.73,0-14.33-5.64-14.33-14.28,0-9.41,5.73-15.11,15-15.11,7.88,0,12.25,4.18,12,11.64H280v.53c0,5.76,3.52,9.29,9.45,9.29,3.58,0,5.87-1.41,7.1-3.47ZM280.3,34.27h10.75c0-3.77-1.56-5.53-4.56-5.53C283.17,28.74,281.08,30.74,280.3,34.27Z"
        />
        <path
          className="comma"
          id="Path_9"
          data-name="Path 9"
          d="M305.13,59.6c4.88-.12,7.49-1.88,7.29-5.11a7.19,7.19,0,0,1-3,.52,4.33,4.33,0,0,1-4.69-4.52c0-2.82,2.09-4.82,5.48-4.82,3.84,0,6.32,2.7,6.32,7.4,0,5.88-4,9.53-11.4,9.53Z"
        />
      </g>
    </StyledSVG>
  );
};

export default Logo;
